import { Route } from 'react-router';
import { TransactionsPage } from '../TransactionsPage';
import { getTransactionsPath } from '../path/path';

export const TransactionRoutes = [
  <Route key={getTransactionsPath()} path={getTransactionsPath()} element={<TransactionsPage />} />,
];
